import './index.scss';

import React from 'react';

export const EntryPoint = ({num, title, desc}) => {
    return (
        <div className="entry-point">
            <div className="number-container">
                {num}
            </div>
            <div className="text-container">
                <h4>{title}</h4>
                <p>{desc}</p>
            </div>
        </div>
    );
};
